import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private showSpinnerSubject: BehaviorSubject<boolean>;
  public showSpinnerValue: Observable<boolean>;

  constructor() {
    this.showSpinnerSubject = new BehaviorSubject<boolean>(false);
    this.showSpinnerValue = this.showSpinnerSubject.asObservable();
  }

  public get showSpinner(): boolean {
    return this.showSpinnerSubject.value;
  }

  public set showSpinner(value: boolean) {
    this.showSpinnerSubject.next(value);
  }


}
